import { render, staticRenderFns } from "./cannotviewComponent.vue?vue&type=template&id=2d4ea1ec&scoped=true"
import script from "./cannotviewComponent.vue?vue&type=script&lang=js"
export * from "./cannotviewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4ea1ec",
  null
  
)

export default component.exports